import styled from 'styled-components'
import IconComponent from 'themes/IconComponent'
import TypographyPro from 'themes/TypographyPro'
import { resetButton, respondAbove } from 'styles/mixins'

export const LocationTypeButtonContainer = styled.button<{ selected?: boolean }>`
	${resetButton}
  	width: 157.5px;
	height: 157.5px;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 12px;
	gap: 12px;
	background-color: var(--bgLight);
	border-radius: var(--borderRadiusM);
	border: solid 1px;
	border-color: ${({ selected }) => (selected ? 'var(--primary)' : 'transparent')};
	box-shadow: var(--shadowSmall);
	justify-content: center;

	${respondAbove.sm`
		width: 250px;
		height: 158px;
	`}
`

export const LocationTypeIcon = styled(IconComponent)`
	width: 72px;
	height: 72px;
`

interface LocationTypeProps {
    onClick: () => void
    selected: boolean
    text: string
    iconUrl: string
}
const LocationTypeButton = ({ onClick, selected, text, iconUrl }: LocationTypeProps) => (
        <LocationTypeButtonContainer onClick={onClick} selected={selected}>
            <LocationTypeIcon asset={iconUrl} />
            <TypographyPro variant='BodyRegularHighlighted'>
                {text}
            </TypographyPro>
        </LocationTypeButtonContainer>
    )

export default LocationTypeButton
